import { render } from "./MyVideo.vue?vue&type=template&id=7799d0ce"
import script from "./MyVideo.vue?vue&type=script&lang=js"
export * from "./MyVideo.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__